import { render } from "./PageContainer.vue?vue&type=template&id=6bc82a6c"
import script from "./PageContainer.vue?vue&type=script&lang=js"
export * from "./PageContainer.vue?vue&type=script&lang=js"

import "./PageContainer.vue?vue&type=style&index=0&id=6bc82a6c&lang=scss"

import exportComponent from "C:\\Users\\33\\Desktop\\2024\\block-explorer-ts\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__